<p-toast></p-toast>

<div class="ui-g-12">
  <div class="ui-g-6 ui-sm-12">
    <label for="patient" style="margin-right: 12px"><b>Choose a Patient :</b>
    </label>
    <p-dropdown id="patient" class="notranslate" [options]="members_list" placeholder="Select" optionLabel="label"
      [(ngModel)]="selectMemeber" (onChange)="onSelectMemeber($event.value)"></p-dropdown>
  </div>
  <div class="ui-g-6 ui-sm-12" *ngIf="this.show_id_dropdown">
    <label for="consultation_id" style="margin-right: 12px"><b>Choose Consultation Request Number :</b>
    </label>
    <p-dropdown id="consultation_id" class="notranslate" [options]="consultation_id_list" placeholder="Select"
      optionLabel="label" [(ngModel)]="consultation_id" (onChange)="onSelectConsultationId()"></p-dropdown>
  </div>
</div>
<div class="ui-g-12" *ngIf="!showTabs">
  <p>Note: Please select Patient and Consultation to proceed.</p>
  <p *ngIf="this.showConsultationText" style="color: red">
    You need to have active consultations to upload documents
  </p>
</div>

<div class="ui-g-12" *ngIf="showTabs">
  <div class="card card-w-title">
    <div>
      <p-tabView [(activeIndex)]="selectedTab" (onChange)="this.onTabChange($event)">
        <p-tabPanel header="Identification" leftIcon="pi pi-pencil" id="home-tab">
          <div class="ui-g">
            <div class="form-group" *ngIf="!id_form.show_form">
              <div class="ui-g-12">
                <div class="text-center">
                  <app-image-enlarger [type]="'IMAGE'" [src]="selectMemeber.value.identification_url"
                    [overlay_class_name]="'pvavatar'" [class_name]="'pvavatar'" [width]="'160'" [height]="'160'">
                  </app-image-enlarger>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="text-center">
                  <p class="text-center">
                    Identification Type:
                    {{ selectMemeber.value.identification_type }}
                  </p>
                  <button pButton style="border-radius: 5px; margin-top: 3px" class="p-button-lg"
                    (click)="id_form.show_form = true" type="button" label="Update"></button>
                </div>
              </div>
            </div>
            <form accept-charset="utf-8" #idForm="ngForm" (ngSubmit)="submitID()" *ngIf="id_form.show_form">
              <div>
                <div class="ui-g-12">
                  <div class="ui-g-12 ui-md-4">
                    <label for="unid">Unique Identification Type <span class="req">*</span> :
                    </label>
                  </div>
                  <div class="ui-g-12 ui-md-8">
                    <p-dropdown id="unid" [options]="this.unique_id" [(ngModel)]="this.id_form.identification_type"
                      placeholder="Select" [style]="{ width: '155px' }" name="unique_id_name" #unique_id_name="ngModel"
                      required>
                    </p-dropdown>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4">
                  <label for="unid">Unique Identification File <span class="req">*</span> :
                  </label>
                </div>
                <div class="ui-g-12 ui-md-8">
                  <p-fileUpload name="unique_id_file" (onSelect)="uploadUniqueIDFiles($event.files)"
                    [showUploadButton]="false" styleClass="p-fileUpload-label-fix"
                    [disabled]="!this.id_form.identification_type" [maxFileSize]="5033165"
                    (onRemove)="resetUnquieIDUpload()" [showCancelButton]="false" [multiple]="false" [fileLimit]="1"
                    accept="image/*" required>
                  </p-fileUpload>
                  <div class="alert alert-danger" role="alert">
                    <p class="text-center text-gray-underline">
                      <span class="font-weight-bold">Note</span>: The file types
                      supported for Unique Identification are JPEG, JPG or PNG.
                    </p>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-g-12 text-center ui-md-4">
                    <button pButton class="p-button-lg" [disabled]="!idForm.valid || id_form.posting" type="submit"
                      label="Upload"></button>
                  </div>
                  <div class="ui-g-12 ui-md-4">
                    <button pButton class="p-button-lg" type="reset" label="Cancel" *ngIf="id_form.has_id" (click)="
                        id_form.show_form = false;
                        id_form.identification = null;
                        id_form.identification_type = null
                      "></button>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="text-center ui-md-6">
                    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" *ngIf="id_form.posting"
                      strokeWidth="6">
                    </p-progressSpinner>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Medical History" leftIcon="pi pi-pencil" id="home-tab" [disabled]="id_form.show_form">
          <app-medical-history-ui-edit [patientData]="this.medicalHistoryApiData"
            (onSaveClick)="processTheData($event)">
          </app-medical-history-ui-edit>
          <br />
          <br />
          <div style="text-align-last: right">
            <p-button type="button" [style]="{
                'margin-right': '5px',
                'margin-top': '3px',
                'background-color': 'white',
                color: '#004AAD',
                'border-radius': '5px'
              }" (click)="RouterNavigation('/patient/dashboard')" label="Cancel" class="p-button-lg"
              icon="pi pi-arrow-left">
            </p-button>
            <p-button type="button" [style]="{
                'margin-right': '5px',
                'border-radius': '5px',
                'margin-top': '3px'
              }" (click)="nextTab()" label="Save and Continue" class="p-button-lg" icon="pi pi-check"></p-button>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Upload Medical Documents" leftIcon="pi pi-upload" id="profile-tab"
          [disabled]="id_form.show_form">
          <div class="ui-g-12">
            <div class="ui-g">
              <div class="ui-g-4 ui-sm-12">
                <p class="bold-text">
                  <b>Storage:
                    {{ this.health_passport_data.formattedStorageSpaceUsed }}
                    used of
                    {{ this.health_passport_data.formattedMaxStorageSpace }}</b>
                </p>
              </div>
              <div class="ui-g-4 ui-sm-12"></div>
              <div class="ui-g-4 ui-sm-12" *ngIf="this.health_passport_data.valid_till != null">
                <p class="bold-text">
                  <b>Validity: {{ this.health_passport_data.valid_till }}
                    <span style="color: #0580c7">( {{ this.health_passport_data.days_left }} Days left for
                      expiry.)</span></b>
                </p>
              </div>
            </div>
            <p-progressBar [value]="this.health_passport_data.percentage" [style]="{ 'background-color': '#dcdcdc' }"
              class="p_progressbar"></p-progressBar>
          </div>
          <div class="ui-g-10"></div>
          <div class="ui-g-12">
            <p-button (click)="showBasicDialog()" icon="pi pi-question" label="Info" styleClass="p-button-lg">
            </p-button>
          </div>
          <p-dialog header="Upload Information" [(visible)]="displayBasic" [style]="{ width: '50vw' }"
            [baseZIndex]="10000">
            <p style="text-align: center">
              Max file size should be less than 4.8MB and upto 3 files are
              allowed. Only images and pdf files are accepted.
            </p>
            <ng-template pTemplate="footer">
              <p-button icon="pi pi-check" (click)="displayBasic = false" label="Yes"
                styleClass="p-button-text"></p-button>
              <p-button icon="pi pi-times" (click)="displayBasic = false" label="No"></p-button>
            </ng-template>
          </p-dialog>
          <p-confirmDialog key="confirm-delete-document" header="Delete Document" acceptLabel="Yes" rejectLabel="No"
            [(visible)]="confirmDialogVisible"></p-confirmDialog>
          <div class="form-group card" *ngFor="let d of Document_data">
            <div class="input-group">
              <div class="ui-g-12 notranslate">
                <label for="fileName" style="word-break: break-word">{{ d.name | titlecase }} : </label>
              </div>
              <div class="row">
                <form>
                  <span class="input-group-btn">
                    <div class="ui-g-12 ui-g">
                      <div *ngIf="d.data.length == 0">
                        <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                          [accept]="acceptedAttachmentTypes" mode="advanced" styleClass="p-fileUpload-label-fix"
                          [maxFileSize]="5033165" [multiple]="false" fileLimit="3" (uploadHandler)="
                            uploadFiles($event.files, d.id, uploadfileform)
                          " customUpload="true"></p-fileUpload>
                        <div class="col-md-1"></div>
                        <div class="ui-g-12">
                          <app-error-messages [api_result]="apiResult">
                          </app-error-messages>
                        </div>
                      </div>
                      <div *ngIf="d.data.length == 1">
                        <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                          [accept]="acceptedAttachmentTypes" mode="advanced" styleClass="p-fileUpload-label-fix"
                          [maxFileSize]="5033165" [multiple]="false" fileLimit="2" (uploadHandler)="
                            uploadFiles($event.files, d.id, uploadfileform)
                          " customUpload="true"></p-fileUpload>
                        <div class="col-md-1"></div>
                        <div class="ui-g-12">
                          <app-error-messages [api_result]="apiResult">
                          </app-error-messages>
                        </div>
                      </div>
                      <div *ngIf="d.data.length == 2">
                        <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                          [accept]="acceptedAttachmentTypes" mode="advanced" styleClass="p-fileUpload-label-fix"
                          [maxFileSize]="5033165" [multiple]="false" fileLimit="1" (uploadHandler)="
                            uploadFiles($event.files, d.id, uploadfileform)
                          " customUpload="true"></p-fileUpload>
                        <div class="col-md-1"></div>
                        <div class="ui-g-12">
                          <app-error-messages [api_result]="apiResult">
                          </app-error-messages>
                        </div>
                      </div>
                      <div *ngIf="d.data.length == 3">
                        <p-fileUpload #uploadfileform [auto]="true" [showCancelButton]="false"
                          [accept]="acceptedAttachmentTypes" mode="advanced" styleClass="p-fileUpload-label-fix"
                          [maxFileSize]="5033165" [multiple]="false" [disabled]="true" fileLimit="0" (uploadHandler)="
                            uploadFiles($event.files, d.id, uploadfileform)
                          " customUpload="true"></p-fileUpload>
                        <div class="col-md-1"></div>
                        <div class="ui-g-12">
                          <app-error-messages [api_result]="apiResult">
                          </app-error-messages>
                        </div>
                      </div>
                    </div>
                  </span>

                  <p-table [value]="d.data" class="ui-g-12">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>File Name</th>
                        <th>Size</th>
                        <th>
                          <i class="pi pi-cog" style="font-size: 1rem"></i>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-file>
                      <tr class="table-text">
                        <td class="ellipsis-overflow-text">
                          <a [href]="file.document_link" target="_blank" rel="noopener noreferrer"
                            style="word-break: break-word">{{ file.document_name }}</a>
                        </td>
                        <td>{{ file.formattedDocumentSize }}</td>
                        <td>
                          <i class="pi pi-trash" style="font-size: 1rem; cursor: pointer" (click)="
                              confirmDocumentDelete(
                                $event,
                                file.document_name,
                                file.file_id,
                                d.id,
                                file.document_key
                              )
                            "></i>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </form>
              </div>
            </div>
          </div>

          <div class="input-group" style="padding-top: 3%">
            <label class="ui-md-4">Other :</label>
            <input class="ui-lg-3" type="text" [pKeyFilter]="name_input" pInputText [(ngModel)]="new_doc_name"
              [value]="new_doc_name" style="margin-bottom: 10px; margin-right: 5px" />
            <span class="pi pi-plus-circle" style="
                margin-bottom: 10px;
                margin-right: 5px;
                font-size: 2em;
                cursor: pointer;
                position: absolute;
              " (click)="addDoc()">
            </span>
          </div>
          <br />
          <br />
          <div style="text-align-last: right">
            <p-button type="button" [style]="{
                'margin-right': '5px',
                'margin-top': '3px',
                'background-color': 'white',
                color: '#004AAD',
                'border-radius': '5px'
              }" (click)="prevTab()" label="Back" class="p-button-lg" icon="pi pi-arrow-left">
            </p-button>
            <p-button type="button" [style]="{
                'margin-right': '5px',
                'border-radius': '5px',
                'margin-top': '3px'
              }" (click)="nextTab()" label="Save and Continue" class="p-button-lg" icon="pi pi-check"></p-button>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Review & Finish" leftIcon="pi pi-check-square" style="padding-bottom: 10%"
          [disabled]="id_form.show_form" id="contact-tab">
          <p-fieldset [style]="{ border: '2px solid #004aad' }">
            <p-header class="pheader"> Personal Information </p-header>
            <div>
              <div class="ui-g-6"><b>Patient Name</b></div>
              <div class="ui-g-6 WordWrap-break" class="notranslate">{{ selectedMemberName }}</div>
            </div>
          </p-fieldset>
          <p-fieldset [style]="{ border: '2px solid #004aad' }">
            <p-header class="pheader"> Medical Information </p-header>
            <div>
              <div>
                <h4 style="font-weight: bold">Current Medical Problems:</h4>
              </div>
              <div>
                <div class="WordWrap-break">
                  {{ medicalHistoryApiData.currentMedicalProblems || 'None' }}
                </div>
              </div>
            </div>

            <div>
              <div>
                <h4 style="font-weight: bold">Medical History</h4>
              </div>
              <div *ngIf="
                  this.medicalHistoryApiData.other_data.empty_medical_history;
                  else show
                ">
                <div>None</div>
              </div>
              <ng-template #show>
                <ul>
                  <li *ngFor="
                      let hist of this.medicalHistoryApiData
                        .selected_past_medical_history_data
                    ">
                    <div *ngIf="hist.selected" class="WordWrap-break">
                      <p>{{ hist.name }}</p>
                    </div>
                  </li>
                </ul>
              </ng-template>
            </div>

            <div>
              <div>
                <h4 style="font-weight: bold">Past Surgical History</h4>
              </div>
              <div>
                <div class="WordWrap-break">
                  {{
                  this.medicalHistoryApiData.past_surgical_history_data ||
                  'None'
                  }}
                </div>
              </div>
            </div>
            <div>
              <div>
                <h4 style="font-weight: bold">Medications and Allergies</h4>
              </div>
            </div>
            <div class="ui-g-12">
              <ng-container *ngIf="this.medicalHistoryApiData.medications.length == 0">
                <div class="ui-g-6">
                  <p>Medications</p>
                </div>
                <div class="ui-g-6">None</div>
              </ng-container>
              <div>
                <div *ngFor="
                    let med of this.medicalHistoryApiData.medications;
                    let i = index
                  ">
                  <div class="ui-g-6">
                    <p>{{ i == 0 ? 'Medications' : '' }}</p>
                  </div>
                  <div class="ui-g-6">
                    <p class="WordWrap-break notranslate">
                      {{ med.name + ' - ' + med.dose }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-g-12">
              <ng-container *ngIf="this.medicalHistoryApiData.allergies.length == 0">
                <div class="ui-g-6">
                  <p>Allergies</p>
                </div>
                <div class="ui-g-6">None</div>
              </ng-container>
              <div>
                <div *ngFor="
                    let aller of this.medicalHistoryApiData.allergies;
                    let i = index
                  ">
                  <div class="ui-g-6">
                    <p>{{ i == 0 ? 'Allergies' : '' }}</p>
                  </div>
                  <div class="ui-g-6">
                    <p class="WordWrap-break">{{ aller.name }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div>
                <h4 style="font-weight: bold">Social History</h4>
              </div>
              <div class="WordWrap-break" [innerHTML]="this.socialHistory_data"></div>
            </div>
            <div>
              <div>
                <h4 style="font-weight: bold">Family History</h4>
              </div>
            </div>
            <ng-container *ngFor="let member of this.medicalHistoryApiData.family_history">
              <div>
                <ng-container *ngIf="member.data.length == 0">
                  <div class="ui-g-6">{{ member.name }}</div>
                  <div class="ui-g-6">None</div>
                </ng-container>
                <ng-container>
                  <div *ngFor="let hist of member.data; let i = index">
                    <div class="ui-g-6">{{ i == 0 ? member.name : '' }}</div>
                    <div class="ui-g-6 WordWrap-break">{{ hist }}</div>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </p-fieldset>
          <p-fieldset [style]="{ border: '2px solid #004aad' }">
            <p-header class="pheader"> Medical Documents </p-header>
            <app-loading type="LOADING_DATA" *ngIf="this.MedicalReports.data.api_result.Posting">
            </app-loading>
            <div class="ui-g" *ngIf="
                !this.MedicalReports.data.api_result.Posting &&
                this.MedicalReports.data.api_result.PromiseResult.success
              ">
              <div class="ui-g-12">
                <h2 class="boldnlabel">Uploaded Medical Records</h2>

                <div *ngIf="
                    this.MedicalReports.data.api_result.PromiseResult
                      ?.success != null
                  ">
                  <app-document-viewer [data]="this.MedicalReports.data.api_result">
                  </app-document-viewer>
                </div>
              </div>
            </div>
            <app-error-messages [api_result]="this.MedicalReports.data.api_result"></app-error-messages>
          </p-fieldset>
          <div class="container ui-g-12">
            <br />
            <br />
            <p>
              <p-checkbox [(ngModel)]="agree" (onChange)="onAgreeChange($event)" [binary]="true"
                name="upload_agree"></p-checkbox>
              <span style="padding-left: 2%">I agree that the above information is accurate to the best of
                my knowledge</span>
            </p>
          </div>
          <br />
          <br />
          <div style="text-align-last: right">
            <p-button type="button" [style]="{
                'margin-right': '5px',
                'margin-top': '3px',
                'background-color': 'white',
                color: '#004AAD',
                'border-radius': '5px'
              }" (click)="prevTab()" label="Back" class="p-button-lg" icon="pi pi-arrow-left">
            </p-button>
            <p-button type="button" [style]="{
                'margin-right': '5px',
                'border-radius': '5px',
                'margin-top': '3px'
              }" (click)="showDialog()" [disabled]="!agree" label="Finish" class="p-button-lg"
              icon="pi pi-check"></p-button>
          </div>
          <p-dialog header="Upload Successful" [(visible)]="display"
            [style]="{ width: '50vw', 'text-align': 'center' }">
            <p>
              Thank you for confirming your medical details. For questions,
              please contact
              <a href="mailto:support@eglobaldoctors.com" target="_blank">support@eglobaldoctors.com</a>
            </p>

            <p>Click here for next steps</p>
            <p-button label="Go to Dashboard" (click)="gotodashboard()"></p-button>
          </p-dialog>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>